import {initiateApp} from './app-initializer';
import {create} from './logger-factory';

initiateApp();
window.fedops.logger = {create};
window.fedops.widgetLogger = {create: (appName, {baseUrl = null, appId = null} = {}) => create(appName, {baseUrl, appId, isWidgetLogger: true})};



// WEBPACK FOOTER //
// ./app.js